export default "__VITE_ASSET__DCrDGlHd__"